/** @format */
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import isPropValid from '@emotion/is-prop-valid';
import { Button } from '@mpb-com/feather/components/atoms/button';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { ContentfulCallToAction } from '@toucan/client/core/contentful';

import { Column, ColumnVariant } from '@toucan/client/shared/components/column';

import { Row, RowStackVariant } from '@toucan/client/blocks/components/row';

import { styles } from './call-to-action.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface CallToActionProps {
    /**
     * Data from the site content basic content block
     */
    data: ContentfulCallToAction;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

export type StyledCallToActionProps = Omit<CallToActionProps, 'data'>;

const StyledCallToAction = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})<StyledCallToActionProps>`
    ${styles}
`;

export const CallToAction: FunctionComponent<CallToActionProps> = ({
    data,
    ...otherProps
}: CallToActionProps) => (
    <StyledCallToAction {...otherProps}>
        <Row
            stackVariant={RowStackVariant.SMALL_TABLET}
            stackGap="var(--layout-spacing-48)"
            className="row"
        >
            <Column
                variant={ColumnVariant.FLUID}
                flexFraction={1}
                className="column"
            >
                <Heading size={HeadingSize.H2}>{data.title}</Heading>
                <div className="description">
                    {data?.description?.json &&
                        documentToReactComponents(data.description.json)}
                </div>
                {data.buttonUrl && (
                    <div className="action">
                        <Button href={data.buttonUrl}>
                            {data.buttonLabel}
                        </Button>
                    </div>
                )}
            </Column>
        </Row>
    </StyledCallToAction>
);
